<template>
  <path
    d="M13.2 7.07016L10.25 11.0002L12.5 14.0002C12.83 14.4402 12.74 15.0702 12.3 15.4002C11.86 15.7302 11.23 15.6502 10.9 15.2002C9.84999 13.8002 8.58999 12.1302 7.79999 11.0602C7.39999 10.5302 6.59999 10.5302 6.19999 11.0602L2.19999 16.3902C1.70999 17.0602 2.17999 18.0002 2.99999 18.0002H21C21.82 18.0002 22.29 17.0602 21.8 16.4002L14.8 7.07016C14.4 6.53016 13.6 6.53016 13.2 7.07016Z"
  />
</template>
